import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@cupcodev/ui";
import type { ReactNode } from "react";

/**
 * DS tooltip around a control. The trigger is a wrapper span so the hint still shows over
 * disabled buttons, which do not emit pointer events themselves.
 */
export const Hint = ({ label, children }: { label: string | undefined; children: ReactNode }) => {
  if (!label) return <>{children}</>;
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild><span className="nave-hint">{children}</span></TooltipTrigger>
        <TooltipContent>{label}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
